import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('benefits_set_external_id',
  'benefits_set_external_ids',
  'show')
const reducer = generator.generate()

export default reducer
